var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loading
    ? _c("span", [
        _vm._m(0),
        _c("img", {
          key: _vm.path,
          class: { "d-none": _vm.loading },
          attrs: { src: _vm.path },
          on: { load: _vm.onLoad, error: _vm.onError },
        }),
      ])
    : _c("img", {
        staticClass: "img-thumbnail thumb-image",
        staticStyle: { width: "120px" },
        attrs: { src: _vm.path },
      })
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "d-flex align-items-center justify-content-center img-thumbnail thumb-image",
        staticStyle: { width: "120px", height: "120px" },
      },
      [_c("i", { staticClass: "far fa-spinner-third fa-spin" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }